import axios from 'axios';

const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const login = (data: any) => {
    return axios.post(`${API_URL}users/login`, data);
}

const signup = (data: any) => {
    return axios.post(`${API_URL}users/`, data);
}

////////////MyProfileSection///////////////
const editInfo = (data: any) => {
    return axios.put(`${API_URL}users/`, data);
}
//////////////////////////////////////////


const logout = (notificationKey?: string) => {
    return axios.get(`${API_URL}users/logout`);
}

export const API = {
    login: login,
    logout: logout,
    signup,
    editInfo
}